/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S10_HeadingInputs */

const tr_servis_s10_heading = /** @type {(inputs: Servis_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Değişiklikler`)
};

const en_servis_s10_heading = /** @type {(inputs: Servis_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Changes`)
};

const de_servis_s10_heading = /** @type {(inputs: Servis_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Änderungen`)
};

const ru_servis_s10_heading = /** @type {(inputs: Servis_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Изменения`)
};

/**
* | output |
* | --- |
* | "10. Changes" |
*
* @param {Servis_S10_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s10_heading = /** @type {((inputs?: Servis_S10_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S10_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s10_heading(inputs)
	if (locale === "de") return de_servis_s10_heading(inputs)
	if (locale === "ru") return ru_servis_s10_heading(inputs)
	return tr_servis_s10_heading(inputs)
});